import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import _sortBy from 'lodash/sortBy';
import TextField from '../../../common/TextField';
import Select from '../../../common/Select';
import _get from 'lodash/get';
import { getTextFromLanguage } from '../../../../helper/languageHelper';
const uuidv4 = require('uuid/v4');

const CollectionTitle = ({
  classes,
  collection,
  collectionId,
  updateCollection,
  languages
}) => {
  const titleId =
    collection.title && collection.title.id ? collection.title.id : uuidv4();
  return (
    <Grid container>
      {languages.map((language, index) => {
        var titleText = '';
        try {
          titleText = getTextFromLanguage(collection.title.text, language);
        } catch (error) {}
        return (
          <Grid
            container
            key={'style-titleText-' + index}
            direction="row"
            alignItems="flex-end"
            spacing={1}
            className={classes.container}
          >
            <Grid item xs={10}>
              <TextField
                dataCy={'Collection-Title-' + language}
                label="Title"
                placeholder="Enter title"
                multiline={true}
                rowsMax="4"
                value={titleText}
                onChange={e => {
                  updateCollection({
                    optimisticResponse: {
                      __typename: 'Mutation',
                      updateCollection: {
                        ...collection,
                        title: {
                          id: titleId,
                          text: [
                            ...languages.map((tempLanguage, index) => {
                              return {
                                langCode: tempLanguage,
                                content:
                                  tempLanguage === language
                                    ? e.target.value
                                    : getTextFromLanguage(
                                        collection.title.text,
                                        tempLanguage
                                      ),
                                __typename: 'TextContent'
                              };
                            })
                          ],
                          __typename: 'Text'
                        }
                      }
                    },
                    variables: {
                      id: collectionId,
                      input: {
                        title: {
                          id: titleId,
                          text: [
                            ...languages.map((tempLanguage, index) => {
                              return {
                                langCode: tempLanguage,
                                content:
                                  tempLanguage === language
                                    ? e.target.value
                                    : getTextFromLanguage(
                                        collection.title.text,
                                        tempLanguage
                                      )
                              };
                            })
                          ]
                        }
                      }
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <Grid
                container
                alignItems="center"
                justify="center"
                style={{
                  height: 38,
                  width: '100%',
                  border: '1px solid #ddd',
                  borderRadius: '3px'
                }}
              >
                {language}
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CollectionTitle;
